// Onay bekleyen kullanıcılar — personel listesinin yanındaki eski panel
// yerine sağdan açılan drawer (design-principles §3.5).

import React from "react";
import { Avatar, Box, Drawer, Skeleton, Typography, alpha } from "@mui/material";
import {
  HourglassEmpty as HourglassIcon,
  Check as CheckIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { ActionButton, DrawerFooter, DrawerHeader } from "../../../../components/atoms";
import EmptyState from "../../../../components/atoms/EmptyState";
import { avatarTone, fullName, initialsOf } from "../../../Secretary/PatientsPage/patientListFormat";
import { COLORS, TYPO } from "../../../../styles/uiConstants";

const paperSx = {
  width: { xs: "100%", sm: 460 },
  bgcolor: COLORS.white,
  boxShadow: "0 8px 32px 0 rgba(60,72,100,0.15)",
  display: "flex",
  flexDirection: "column",
};

export default function PendingStaffDrawer({
  open,
  onClose,
  users,
  isLoading,
  onApprove,
  onReject,
  approving,
  rejecting,
  palette,
}) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: paperSx }}>
      <DrawerHeader
        icon={<HourglassIcon />}
        bgcolor={COLORS.warning}
        title="Onay Bekleyenler"
        subtitle="Kliniğinize katılmak için onay bekleyen kullanıcılar"
        onClose={onClose}
      />

      <Box sx={{ px: 3, py: 1.5, bgcolor: COLORS.warningLightest, borderBottom: `1px solid ${COLORS.slate200}`, flexShrink: 0 }}>
        <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate600, lineHeight: 1.5 }}>
          Onayladığınız kullanıcı personel listesine eklenir. Reddedilen başvuru listeden kalkar.
        </Typography>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        {isLoading ? (
          [0, 1, 2].map((i) => (
            <Box key={i} sx={{ px: 3, py: 1.5, display: "flex", alignItems: "center", gap: 1.5, borderBottom: `1px solid ${COLORS.slate100}` }}>
              <Skeleton variant="circular" width={34} height={34} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="55%" />
                <Skeleton variant="text" width="35%" />
              </Box>
            </Box>
          ))
        ) : users.length === 0 ? (
          <Box sx={{ pt: 4 }}>
            <EmptyState
              variant="illustrated-sm"
              icon={<HourglassIcon />}
              title="Onay bekleyen kullanıcı yok"
              description="Kliniğinize katılmak isteyen yeni kullanıcılar onayınıza düştüğünde burada görünür."
            />
          </Box>
        ) : (
          users.map((u) => {
            const tone = avatarTone(u);
            return (
              <Box
                key={u._id}
                sx={{ px: 3, py: 1.5, display: "flex", alignItems: "center", gap: 1.5, borderBottom: `1px solid ${COLORS.slate100}` }}
              >
                <Avatar sx={{ width: 34, height: 34, fontSize: 12.5, fontWeight: 600, bgcolor: alpha(tone, 0.14), color: tone }}>
                  {initialsOf(u)}
                </Avatar>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: TYPO.body, fontWeight: 600, color: COLORS.slate800 }} noWrap>
                    {fullName(u)}
                  </Typography>
                  <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate500 }} noWrap>
                    {u.email || u.tcNo || "—"}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 0.75, flexShrink: 0 }}>
                  <ActionButton
                    variant="delete"
                    compact
                    tone="soft"
                    palette={palette}
                    label="Reddet"
                    icon={<CloseIcon sx={{ fontSize: 14 }} />}
                    disabled={rejecting}
                    onClick={() => onReject(u)}
                  />
                  <ActionButton
                    variant="confirm"
                    compact
                    palette={palette}
                    label="Onayla"
                    icon={<CheckIcon sx={{ fontSize: 14 }} />}
                    disabled={approving}
                    onClick={() => onApprove(u)}
                  />
                </Box>
              </Box>
            );
          })
        )}
      </Box>

      <DrawerFooter onCancel={onClose} cancelLabel="Kapat" fullWidth />
    </Drawer>
  );
}
